<div class="container locker-date">
  <div class="row p-0 m-0 mb-4">
    <div class="col mr-auto ml-auto">
        <h2 class="text-center">{{'lockerdate.title'|traduccion}}</h2>
    </div>
  </div>
  <div class="row section-block">
    <div *ngIf="uniquePrice != null" class="col">
      <app-block-date [class.inactive]="activeSection !== 'reservation'"
      showDetail="true" 
      [minPrice]="minPrice" 
      [minPeriod]="uniquePrice?.minPeriod"
      [maxPeriod]="uniquePrice?.maxPeriod"
      (callBack)="callBack($event)"></app-block-date>
    </div>
    <div *ngIf="subscriptions.length > 0" class="col">
      <app-block-date [class.inactive]="activeSection !== 'subscription'"
      showDetail="true" 
      [minPrice]="minPrice" 
      [subscriptions]="subscriptions"
      activeSection="subscription"
      (callBack)="callBack($event)"></app-block-date>
    </div>
  </div>
</div>